<!--RIS-->
<!--v1.0-->
<!--状态记录-->
<!--陈宇-->
<!--2018.08.14-->
<template>
  <div class="record-continer">
    <el-row id="record-wrapper" class="record-wrapper">
      <el-row class="record-subheader">
        状态记录
      </el-row>
      <el-row class="main">
        <el-col :span="24" class="record-main">
          <!--基本资料开始-->
          <div class="content-wrapper">
            <el-row style="padding:10px 0px;">
              <el-col :span='6'>
                <el-row>
                  <el-col style="text-align:right" :span='12'>
                    患者姓名：
                  </el-col>
                  <el-col style="text-align:left;" :span='12'>
                    {{recordPatient.patientName}}
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span='6'>
                <el-row>
                  <el-col style="text-align:right;" :span='12'>
                    性别：
                  </el-col>
                  <el-col style="text-align:left;" :span='12'>
                    {{recordPatient.sex}}
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span='6'>
                <el-row>
                  <el-col style="text-align:right;" :span='12'>
                    年龄：
                  </el-col>
                  <el-col style="text-align:left;word-break: break-all;" :span='12'>
                    {{recordPatient.age}}
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span='6'>
                <el-row>
                  <el-col style="text-align:right" :span='12'>
                    影像号：
                  </el-col>
                  <el-col style="text-align:left" :span='12'>
                    {{recordPatient.patientNo}}
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
            <el-row  style="padding:10px 0px;">
              <el-col :span='6'>
                <el-row>
                  <el-col style="text-align:right;" :span='12'>
                    检查号：
                  </el-col>
                  <el-col style="text-align:left;" :span='12'>
                    {{recordPatient.performNo}}
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span='6'>
                <el-row>
                  <el-col style="text-align:right" :span='12'>
                    设备类型：
                  </el-col>
                  <el-col style="text-align:left" :span='12'>
                    {{recordPatient.modalityName}}
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span='6'>
                <el-row>
                  <el-col style="text-align:right" :span='12'>
                    检查部位：
                  </el-col>
                  <el-col style="text-align:left" :span='12'>
                    {{recordPatient.bodyParts}}
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span='6'>
                <el-row>
                  <el-col style="text-align:right" :span='12'>
                    检查项目：
                  </el-col>
                  <el-col style="text-align:left;word-break: break-all;" :span='12'>
                    {{recordPatient.checkingItems}}
                  </el-col>
                </el-row>
              </el-col>
            </el-row>
          </div>
           <!--基本资料结束-->
           <div class="record-cont" v-if='recordList.length > 0'>
             <el-row class="cont-header" >
               <el-col :span='3'>状态</el-col>
               <el-col :span='6'>修改时间</el-col>
               <el-col :span='3'>修改人</el-col>
               <el-col :span='6'>修改内容（检查所见）</el-col>
               <el-col :span='6'>修改内容（诊断所得）</el-col>
             </el-row>
             <el-row  class="cont-line" v-for='recordLists in recordList' :key='recordLists.status'>
                <el-col class="cont-line-box" :span='3'>
                  {{recordLists.statusName}}
                  <el-tooltip placement="top" effect="light" v-if="recordLists.statusName === '已驳回'">
                    <div slot="content">
                      <span style="line-height:80px;width: 100%;text-overflow: ellipsis;display: inline-block;overflow: hidden;white-space: nowrap;">{{recordLists.rejectReason}}</span>
                    </div>
                    <i class="el-icon-info"></i>
                  </el-tooltip>
                </el-col>
                <el-col :span='6'><span style="line-height:80px;">{{recordLists.menderTime}}</span></el-col>
                <el-col :span='3'><span style="line-height:80px;">{{recordLists.menderName}}</span></el-col>
                <el-col :span='6'>
                  <el-tooltip :content="recordLists.wys" placement="top" effect="light">
                    <span style="line-height:80px;width: 100%;text-overflow: ellipsis;display: inline-block;overflow: hidden;white-space: nowrap;">{{recordLists.wys}}</span>
                  </el-tooltip>
                </el-col>
               <el-col :span='6'>
                 <el-tooltip :content="recordLists.wyg" placement="top" effect="light">
                    <span style="line-height:80px;width: 100%;text-overflow: ellipsis;display: inline-block;overflow: hidden;white-space: nowrap;">{{recordLists.wyg}}</span>
                  </el-tooltip>
               </el-col>
             </el-row>
            </div>
            <div v-else style="width:100%;margin-top:20px;height: calc(100vh - 260px);text-align:center;background:#f8f8f8;">
              <img src="../../assets/empty_01.png" alt="" style="height: calc(100vh - 313px);width: auto;"  />
            </div>
        </el-col>
      </el-row>
      
    </el-row>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'record',
  data() {
    return {
      recordid: '',
      tableData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1518 弄'
      }, {
        date: '2016-05-04',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1517 弄'
      }, {
        date: '2016-05-01',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1519 弄'
      }, {
        date: '2016-05-03',
        name: '王小虎',
        address: '上海市普陀区金沙江路 1516 弄'
      }],
      reportId: ''
    }
  },
  created: function() {
    this.reportId = this.$route.query.reportId
    this.init()
  },
  computed: {
    ...mapGetters([
      'recordPatient',
      'recordList'
    ])
  },
  methods: {
    init: function() {
      this.$store
        .dispatch('getstateRecord', this.reportId)
        .then(() => {
        })
        .catch(() => {
        })
    }
  }
}
  </script>

  <style  rel="stylesheet/scss" lang="scss" scoped>
  .record-continer{
    overflow-y: auto;
    height:100%;
    .record-wrapper{
      width:95%;
      margin: 0 auto;
      padding: 30px 0;
    }
    .record-subheader{
      color: #3A4A64;
      height: 60px;
      line-height: 60px;
      border-bottom:2px solid #ddd;
      font-size: 18px;
    }
    .main{
      margin-top:20px;
      .el-menu{
        border:none;
        height: calc(100vh - 80px);
        background-color: #f8f8f8;
        .el-menu-item{
          height: 65px;
          line-height: 65px;
        }
      }
      .record-main{
        .content-wrapper{
          background: #f8f8f8;  
          line-height: 20px;
        }
        .record-cont{
          background: #f8f8f8; 
          border-top:2px solid #ddd;
          margin-top: 20px;
        }
        .cont-header{
          padding: 0px 20px;
          line-height: 40px;
        }
        
        .cont-line{
          padding: 0px 20px;
          position: relative;
        }
        .cont-line-box{
          line-height: 80px;
          height: 80px;
          position: relative;
        }
      }
    }
  }
  </style>
